// extracted by mini-css-extract-plugin
module.exports = {"component":"PageInfo_component__NQeNh"};